import { useMemo } from 'react';
import { Select as SelectAntd } from 'antd';
import s from './index.module.css';
import { SearchOutlined } from '@ant-design/icons';
import classNames from 'classnames';

const ALL_VALUE = 'all';

/** multiple + «Все …»: выбрал all — сброс остальных, выбрал курс — all убирается */
const resolveAllOptionChange = (prev, value, allValue = ALL_VALUE) => {
	const all = String(allValue);

	if (!value?.length) {
		return [all];
	}

	const prevArr = [].concat(prev ?? []).map(String);
	const next = [].concat(value).map(String);

	if (!next.includes(all)) {
		return next;
	}

	if (next.length === 1 || !prevArr.includes(all)) {
		return [all];
	}

	return next.filter((item) => item !== all);
};

const Select = ({
	fields,
	allOption = /** @type {{ label: import('react').ReactNode, value?: string | number } | undefined} */ (undefined),
	className = '',
	wrapperClassName = '',
	hideSearchIcon = false,
	compact = false,
}) => {
	const allValue = allOption ? String(allOption.value ?? ALL_VALUE) : null;

	const options = useMemo(() => {
		if (!allOption) {
			return fields?.options;
		}

		const opts = fields?.options ?? [];

		if (opts.some((item) => String(item.value) === allValue)) {
			return opts;
		}

		return [{ label: allOption.label, value: allValue }, ...opts];
	}, [allOption, allValue, fields?.options]);

	const onChange = (value) => {
		if (!allOption) {
			fields?.onChange?.(value);
			return;
		}

		fields?.onChange?.(resolveAllOptionChange(fields?.value, value, allValue));
	};

	return (
		<div
			className={classNames(
				s.selectWrapper,
				{ [s.compact]: compact },
				{ [s.withoutSearchIcon]: hideSearchIcon },
				{ [wrapperClassName]: !!wrapperClassName },
			)}
		>
			{!hideSearchIcon &&
				(fields?.value?.length === 0 || !fields.value || fields.mode !== 'multiple') && (
					<SearchOutlined className={s.searchIcon} />
				)}
			<SelectAntd
				className={classNames('multipleSearhNewDesign', s.select, { [className]: !!className })}
				popupMatchSelectWidth={false}
				{...fields}
				popupClassName={classNames(s.popup, fields?.popupClassName)}
				options={options}
				onChange={onChange}
			/>
		</div>
	);
};

export default Select;
